// /src/components/layout/EliteThemeSwitcher.jsx
// VERSÃO 14.0 SUPREMA - 7 ESTAÇÕES DE COMANDO (GOLD SYNC)

import React, { useState, useEffect } from 'react';
import { motion } from 'framer-motion';
import { 
  FiSun, FiMoon, FiStar, FiZap, FiCpu, FiFeather, FiActivity 
} from 'react-icons/fi';

const THEMES = [
  { id: 'default', name: 'Branco', icon: <FiSun />, color: '#0ea5e9' },
  { id: 'elite-dark', name: 'Black', icon: <FiMoon />, color: '#22d3ee' },
  { id: 'elite-diamond', name: 'Azure', icon: <FiZap />, color: '#00d4ff' },
  { id: 'elite-gold', name: 'Gold', icon: <FiStar />, color: '#d4af37' },
  { id: 'elite-cedar', name: 'Amadeirado', icon: <FiFeather />, color: '#d2691e' },
  { id: 'elite-ruby', name: 'Ruby', icon: <FiActivity />, color: '#e11d48' },
  { id: 'black-black', name: 'Neon', icon: <FiCpu />, color: '#1d4ed8' },
];

export default function EliteThemeSwitcher() {
  const [activeTheme, setActiveTheme] = useState(localStorage.getItem('mos-theme') || 'elite-dark');

  useEffect(() => {
    // 🛡️ PROTOCOLO DE LIMPEZA GERAL
    const body = document.body;
    THEMES.forEach(t => {
      if (t.id !== 'default') body.classList.remove(t.id);
    });
    
    // 🛰️ INJEÇÃO DA NOVA PATENTE
    if (activeTheme !== 'default') {
      body.classList.add(activeTheme);
    }
    
    localStorage.setItem('mos-theme', activeTheme);
  }, [activeTheme]);

  return (
    <div className="flex items-center bg-black/20 dark:bg-white/5 backdrop-blur-xl p-1.5 rounded-[1.5rem] border border-white/10 shadow-2xl overflow-x-auto no-scrollbar max-w-full">
      {THEMES.map((theme) => (
        <button
          key={theme.id}
          onClick={() => setActiveTheme(theme.id)}
          className="relative p-3 rounded-xl transition-all duration-300 group flex items-center justify-center min-w-[44px]"
          title={theme.name}
        >
          {/* Indicador Ativo (Framer Motion) */}
          {activeTheme === theme.id && (
            <motion.div
              layoutId="activeThemeOverlay"
              className="absolute inset-0 rounded-xl shadow-[0_0_20px_rgba(0,0,0,0.3)]"
              style={{ backgroundColor: 'var(--accent-color)' }}
              transition={{ type: "spring", stiffness: 350, damping: 25 }}
            />
          )}
          
          <span 
            className="relative z-10 text-xl transition-all duration-500 group-hover:scale-125"
            style={{ 
              color: activeTheme === theme.id ? '#000' : 'var(--text-secondary)',
              filter: activeTheme === theme.id ? 'brightness(0)' : 'none'
            }}
          >
            {theme.icon}
          </span>

          {/* Tooltip Industrial (Opcional, visível no Desktop) */}
          <span className="absolute -top-10 left-1/2 -translate-x-1/2 px-2 py-1 bg-black text-white text-[8px] font-black uppercase tracking-widest rounded opacity-0 group-hover:opacity-100 transition-opacity pointer-events-none whitespace-nowrap border border-white/10 shadow-xl">
            {theme.name}
          </span>
        </button>
      ))}
    </div>
  );
}